import { atom } from "jotai";

import {
  DiningBookingKnownPeopleAtom,
  DiningBookingWizardDataAtom,
} from "../../stores";

export const removeKnownDiningPersonAtom = atom(
  null,
  (get, set, playerId: string) => {
    const wizardData = get(DiningBookingWizardDataAtom);
    const knownPeople = get(DiningBookingKnownPeopleAtom);
    const updated = knownPeople.filter(
      (person) => person.playerId !== playerId
    );

    if (updated.length === knownPeople.length) {
      return;
    }

    set(DiningBookingKnownPeopleAtom, updated);

    if (!wizardData) {
      return;
    }

    const otherKnownIds = updated
      .map((person) => person.playerId)
      .filter((id) => id !== wizardData.ownerId);

    set(DiningBookingWizardDataAtom, {
      ...wizardData,
      otherPatronIds: otherKnownIds,
    });
  }
);
